import { Suspense } from 'react';

export const Loadable = (Component: any) => {
  const LoadableWrapper = (props: any) => (
    <Suspense fallback={null}>
      <Component {...props} />
    </Suspense>
  );
  const name = Component?.displayName ?? Component?.name ?? 'Component';
  LoadableWrapper.displayName = `Loadable(${name})`;
  return LoadableWrapper;
};
